import { render } from "./Search.vue?vue&type=template&id=4ddd3e15&scoped=true"
import script from "./Search.vue?vue&type=script&lang=js"
export * from "./Search.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-4ddd3e15"

export default script